import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import * as api from "../../common/manipurCommon/API";
import * as func from "../../common/manipurCommon/FunctionCalls";
import Utils from "../../common/manipurCommon/Utils";
import Select from "react-select";
import { usePermissions } from "../../common/PermissionContext";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import Swal from "sweetalert2";

const ExternalPerformance = () => {

    const [performanceList, setPerformanceList] = useState<any[]>([]);
    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [competitionList, setCompetitionList] = useState<any[]>([]);
    const [sportCategoryList, setSportCategoryList] = useState<any[]>([]);
    const [compCategoryList, setCompCategoryList] = useState<any[]>([]);
    const [compFormatList, setCompFormatList] = useState<any[]>([]);
    const [compClassList, setCompClassList] = useState<any[]>([]);
    const [performanceId, setPerformanceId] = useState("");
    const [formatList, setFormatList] = useState<any[]>([]);
    const [sportList, setSportList] = useState<any[]>([]);
    const [athleteId, setAthleteId] = useState("");
    const [compId, setCompId] = useState("");
    const [sprtCatId, setSprtCatId] = useState("");
    const [sportId, setSportId] = useState("");
    const [compCatId, setCompCatId] = useState("");
    const [compFrmtId, setCompFrmtId] = useState("");
    const [compClassId, setCompClassId] = useState("");
    const [formatId, setFormatId] = useState("");
    const [compCount, setCompCount] = useState("");
    const [athltRank, setAthltRank] = useState("");
    const [performStat, setPerformStat] = useState("");
    const [performStatus, setPerformStatus] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [remarks, setRemarks] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    useEffect(() => {
        fetchExternalPerformance();
    }, []);

        async function fetchExternalPerformance() {
            setIsLoading(true);
            const externalPerformanceResponse = await func.externalPerformance(null);
            setPerformanceList(Array.isArray(externalPerformanceResponse) ? externalPerformanceResponse : [])
            setIsLoading(false);
        }

    const filteredData = performanceList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const competitionRender = (rowData) => {
        return <span>{rowData.competitionName}</span>;
    };

    const athleteRender = (rowData) => {
        return <span>{rowData.athleteName}</span>;
    };

    const formatRender = (rowData) => {
        return <span>{rowData.formatedData}</span>;
    };

    const rankcompetitorCountRender = (rowData:any) => {
        return <span>{rowData.extComAthleterank} / {rowData.competitorscount}</span>;
    };

    const rankRender = (rowData) => {
        return <span>{rowData.extComAthleterank}</span>;
    };

    const performanceStatRender = (rowData) => {
        return <span>{rowData.extComAthletePerformanceStat}</span>;
    };

    const lastMeetAttemptsRender = (rowData: any) => {
        const attempts = rowData?.lastMeetAttempts;

        if (!attempts) {
            return <span>-</span>;
        }

        const renderAttemptCells = (
            type: "snatch" | "cleanAndJerk"
        ) => {
            return [1, 2, 3].map((num) => {
                const attempt = attempts?.[type]?.find(
                    (item: any) => item.attempt_num === num
                );

                return (
                    <td key={num}>
                        {attempt ? (
                            <>
                                {attempt.weight}{" "}
                                <span
                                    className={
                                        attempt.result
                                            ? "text-success"
                                            : "text-danger"
                                    }
                                >
                                    {attempt.result ? "✓" : "✗"}
                                </span>
                            </>
                        ) : (
                            "-"
                        )}
                    </td>
                );
            });
        };

        return (
            <div
                style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "flex-start",
                }}
            >
                {/* SNATCH TABLE */}
                <table
                    className="table table-bordered table-sm mb-0 text-center"
                    style={{
                        width: "220px",
                        minWidth: "220px",
                    }}
                >
                    <thead>
                        <tr>
                            <th colSpan={3}>SNATCH</th>
                        </tr>

                        <tr>
                            <th>1</th>
                            <th>2</th>
                            <th>3</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            {renderAttemptCells("snatch")}
                        </tr>
                    </tbody>
                </table>

                {/* CLEAN & JERK TABLE */}
                <table
                    className="table table-bordered table-sm mb-0 text-center"
                    style={{
                        width: "220px",
                        minWidth: "220px",
                    }}
                >
                    <thead>
                        <tr>
                            <th colSpan={3}>CLEAN &amp; JERK</th>
                        </tr>

                        <tr>
                            <th>1</th>
                            <th>2</th>
                            <th>3</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            {renderAttemptCells("cleanAndJerk")}
                        </tr>
                    </tbody>
                </table>                
            </div>
        );
    };

    const platformEffRender = (rowData) => {
        return <span>{rowData.platformEfficiency}</span>;
    };
    
    const weightRender = (rowData) => {
        return <span>{rowData.extComWeighInWeight}</span>;
    };

    const weightClassRender = (rowData) => {
        return <span>{rowData.extComWeightClass}</span>;
    };
    
    const sinclairCoeffRender = (rowData) => {
        return <span>{rowData.extComSinclairCoefficient}</span>;
    };

    const robiRender = (rowData) => {
        return <span>{rowData.extComRobiWorldRecordTotal}</span>;
    };

    const remarksRender = (rowData) => {
        return <span>{rowData.remarks}</span>;
    };

    const statusRender = (rowData) => {
        return <span>{(rowData.status == "1") ? "Pending" : (rowData.status == "2") ? "Completed" : "Disqualified"}</span>;
    };

    async function newPerformance() {
        setIsEdit(false);
        const athltResponse = await func.externalCompAthletes(null);
        setAthleteList(Array.isArray(athltResponse) ? athltResponse : []);
        const eventResponse = await func.externalCompEvents(null);
        setCompetitionList(Array.isArray(eventResponse) ? eventResponse : []);
        const compFrmtResponse = await func.externalCompFormat(null);
        setCompFormatList(Array.isArray(compFrmtResponse) ? compFrmtResponse : []);
        const sportCategoryResponse = await func.sportCategory(null);
        setSportCategoryList(Array.isArray(sportCategoryResponse) ? sportCategoryResponse : []);
        const sportResponse = await func.externalSports(null);
        setSportList(Array.isArray(sportResponse) ? sportResponse : []);
        const categoryResponse = await func.externalCompCategory(null);
        setCompCategoryList(Array.isArray(categoryResponse) ? categoryResponse : []);
        const classResponse = await func.externalCompClass(null);
        setCompClassList(Array.isArray(classResponse) ? classResponse : []);
        const formatResponse = await func.externalResultFormats(null);
        setFormatList(Array.isArray(formatResponse) ? formatResponse : [])
        setCompId("");
        setAthleteId("");
        setSprtCatId("");
        setSportId("");
        setCompCatId("");
        setCompClassId("");
        setFormatId("");
        setCompCount("");
        setAthltRank("");
        setPerformStat("");
        setRemarks("");
        setOpenModal(true);
    }

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editPerformance(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const eventId = rowData.extComEventId;
        return (
            <Link to="#" onClick={() => deletePerformance(eventId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function editPerformance(rowData: { extComPerformanceId: any; }) {
        const perfrmId = rowData.extComPerformanceId;
        setIsEdit(true)
        setOpenModal(true)
        const athltResponse = await func.externalCompAthletes(null);
        setAthleteList(Array.isArray(athltResponse) ? athltResponse : []);
        const eventResponse = await func.externalCompEvents(null);
        setCompetitionList(Array.isArray(eventResponse) ? eventResponse : []);
        const sportCategoryResponse = await func.sportCategory(null);
        setSportCategoryList(Array.isArray(sportCategoryResponse) ? sportCategoryResponse : []);
        const sportResponse = await func.externalSports(null);
        setSportList(Array.isArray(sportResponse) ? sportResponse : []);
        const categoryResponse = await func.externalCompCategory(null);
        setCompCategoryList(Array.isArray(categoryResponse) ? categoryResponse : []);
        const classResponse = await func.externalCompClass(null);
        setCompClassList(Array.isArray(classResponse) ? classResponse : []);
        const compFrmtResponse = await func.externalCompFormat(null);
        setCompFormatList(Array.isArray(compFrmtResponse) ? compFrmtResponse : []);
        const formatResponse = await func.externalResultFormats(null);
        setFormatList(Array.isArray(formatResponse) ? formatResponse : [])
        const getDetails = await func.externalPerformance(perfrmId);
        setPerformanceId(getDetails.extComPerformanceId)
        setCompId(getDetails.extComCompetitionId);
        setAthleteId(getDetails.extComAthleteId);
        setSprtCatId(getDetails.extComSportCategoryId);
        setSportId(getDetails.extComSportId);
        setCompCatId(getDetails.extComCategoryId);
        setCompClassId(getDetails.extComClassId);
        setFormatId(getDetails.extComFormatId);
        setCompFrmtId(getDetails.extComFormatId)
        setCompCount(getDetails.competitorscount);
        setAthltRank(getDetails.extComAthleterank);
        setPerformStat(getDetails.extComAthletePerformanceStat);
        setRemarks(getDetails.remarks);
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updatePerformance();
            } else {
                const formData = new FormData();
                formData.append("extComCompetitionId", compId);
                // formData.append("extComSportCategoryId", sprtCatId);
                // formData.append("extComSportId", sportId);
                // formData.append("extComCategoryId", compCatId);
                // formData.append("extComClassId", compClassId);
                // formData.append("extComFormatId", formatId);
                formData.append("extComFormatId", compFrmtId);
                formData.append("extComAthleteId", athleteId);
                formData.append("competitorscount", compCount);
                formData.append("extComAthleterank", athltRank);
                formData.append("extComAthletePerformanceStat", performStat);
                formData.append("extComRemarks", remarks);

                const createLevel = api.ExternalCompetitionResults;
                fetch(createLevel, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    // window.location.reload(); // 🔁 Reload only after OK is clicked
                                    setOpenModal(false);
                                    fetchExternalPerformance();
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            })
                        }
                    })
            }
        }
    }

    function updatePerformance() {
        const formData = new FormData();
        formData.append("extComCompetitionId", compId);
        // formData.append("extComSportCategoryId", sprtCatId);
        // formData.append("extComSportId", sportId);
        // formData.append("extComCategoryId", compCatId);
        // formData.append("extComClassId", compClassId);
        // formData.append("extComFormatId", formatId);
        formData.append("extComFormatId", compFrmtId);
        formData.append("extComAthleteId", athleteId);
        formData.append("competitorscount", compCount);
        formData.append("extComAthleterank", athltRank);
        formData.append("extComAthletePerformanceStat", performStat);
        formData.append("extComRemarks", remarks);
        formData.append("status", performStatus);

        const updateLevel = api.ExternalCompetitionResults + '/' + performanceId;
        fetch(updateLevel, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                console.log(result);

                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setIsEdit(false);
                            setOpenModal(false);
                            fetchExternalPerformance();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function deletePerformance(eventId: string) {
        const deleteLevel = api.ExternalCompetitionResults + '/' + eventId + '/0';
        fetch(deleteLevel, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setOpenModal(false);
                            fetchExternalPerformance();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })

    }

    return (
        <>{isLoading && (
            <div id="global-loader">
                <div className="loader-img">
                    <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                </div>
            </div>
        )}
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Performance</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newPerformance() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Competition">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                            </div>
                            <div className="row col-lg-12 mb-10">
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComEventName"
                                                header="Competiton"
                                                body={competitionRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComAthleteId"
                                                header="Athlete"
                                                body={athleteRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {/* <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComFormatId"
                                                header="Format"
                                                body={formatRender}
                                                className="table-inset-btn"
                                            ></Column> */}
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="competitorscount"
                                                header="Rank/Competitors Count"
                                                body={rankcompetitorCountRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComWeighInWeight"
                                                header="Weight"
                                                body={weightRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComWeightClass"
                                                header="Weight Class"
                                                body={weightClassRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {/* <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComAthletePerformanceStat"
                                                header="Performance Stat"
                                                body={performanceStatRender}
                                                className="table-inset-btn"
                                            ></Column> */}
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="platformEfficiency"
                                                header="Platform Efficiency"
                                                body={platformEffRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComSinclairCoefficient"
                                                header="Sinclair Coefficient"
                                                body={sinclairCoeffRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComRobiWorldRecordTotal"
                                                header="Robi World Record"
                                                body={robiRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase text-center"
                                                field="lastMeetAttempts"
                                                header="Last Meet Attempts"
                                                body={lastMeetAttemptsRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="remarks"
                                                header="Remarks"
                                                body={remarksRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="status"
                                                header="Status"
                                                body={statusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                size="xl"
                centered
                show={openModal}>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Performance</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="row">
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Competition </label>
                                    <Select
                                        value={competitionList.find(cmp => cmp.extComEventId === compId) ? {
                                            value: compId,
                                            label: competitionList.find(cmp => cmp.extComEventId === compId).extComEventName
                                        } : null}
                                        onChange={(e) => {
                                            setCompId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={competitionList.map(cmp => ({
                                            value: cmp.extComEventId,
                                            label: cmp.extComEventName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Athlete</label>
                                    <Select
                                        value={athleteList.find(athlt => athlt.extComAthleteId === athleteId) ? {
                                            value: athleteId,
                                            label: athleteList.find(athlt => athlt.extComAthleteId === athleteId).extComAthleteName
                                        } : null}
                                        onChange={(e) => {
                                            setAthleteId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={athleteList.map(athlt => ({
                                            value: athlt.extComAthleteId,
                                            label: athlt.extComAthleteName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            {/* <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Sport Category</label>
                                    <Select
                                        value={sportCategoryList.find(sprt => sprt.id === sprtCatId) ? {
                                            value: sprtCatId,
                                            label: sportCategoryList.find(sprt => sprt.id === sprtCatId).name
                                        } : null}
                                        onChange={(e) => {
                                            setSprtCatId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={sportCategoryList.map(sprt => ({
                                            value: sprt.id,
                                            label: sprt.name
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Sport</label>
                                    <Select
                                        value={sportList.find(sprt => sprt.extComSportId === sportId) ? {
                                            value: sportId,
                                            label: sportList.find(sprt => sprt.extComSportId === sportId).extComSportName
                                        } : null}
                                        onChange={(e) => {
                                            setSportId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={sportList.map(sprt => ({
                                            value: sprt.extComSportId,
                                            label: sprt.extComSportName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Competition Category</label>
                                    <Select
                                        value={compCategoryList.find(ctgry => ctgry.extcomCategoryId === compCatId) ? {
                                            value: compCatId,
                                            label: compCategoryList.find(ctgry => ctgry.extcomCategoryId === compCatId).extComCategoryName
                                        } : null}
                                        onChange={(e) => {
                                            setCompCatId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={compCategoryList.map(ctgry => ({
                                            value: ctgry.extcomCategoryId,
                                            label: ctgry.extComCategoryName
                                        }))}>
                                    </Select>
                                </div>
                            </div> */}
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Competition Format</label>
                                    <Select
                                        value={compFormatList.find(frmt => frmt.extComFormatId === compFrmtId) ? {
                                            value: compFrmtId,
                                            label: compFormatList.find(frmt => frmt.extComFormatId === compFrmtId).extComFormatName
                                        } : null}
                                        onChange={(e) => {
                                            setCompFrmtId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={compFormatList.map(frmt => ({
                                            value: frmt.extComFormatId,
                                            label: frmt.extComFormatName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Competitors Count</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="compiCount"
                                        value={compCount}
                                        onChange={(e) => { setCompCount(e.target.value) }}
                                        placeholder="Enter Competitors Count" />
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Rank</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="rank"
                                        value={athltRank}
                                        onChange={(e) => { setAthltRank(e.target.value) }}
                                        placeholder="Enter Rank" />
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Performance Stat</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="stat"
                                        value={performStat}
                                        onChange={(e) => { setPerformStat(e.target.value) }}
                                        placeholder="Enter Performance Stat" />
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Remarks</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="remarks"
                                        value={remarks}
                                        onChange={(e) => { setRemarks(e.target.value) }}
                                        placeholder="Enter Remarks" />
                                </div>
                            </div>
                            {/* {isEdit ?
                                <>
                                <div className="col-lg-3 mb-30">
                                    <div className="row">
                                        <div className="mb-10 col-lg-6" style={{ paddingTop: "2.5rem" }}>
                                            <label className="form-label">Status</label>
                                        </div>
                                        <div className="mb-10 col-lg-2" style={{ paddingTop: "2.5rem" }}>
                                            <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                <input
                                                    className="form-check-input text-end"
                                                    type="checkbox"
                                                    checked={performStatus === '1'}
                                                    id="performStatus"
                                                    onChange={(e) => {
                                                        setPerformStatus(e.target.checked ? '1' : '0')
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </> : null
                            } */}
                        </div>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />Save</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>
        </>
    );
};

export default ExternalPerformance;